import React, { Component } from 'react'
import { Grid, Box } from '@mui/material'
import { KeDoContext } from '../../kedo-context'

interface ItemCounterProps {
    pager: {
        current: number
        limit: number
        items: number
        pages: number
    }
}

class ItemCounter extends Component<ItemCounterProps> {
    static contextType = KeDoContext

    countItems() {
        const kedo = this.context
        const currentPage = this.props.pager.current + 1
        const currentItems = currentPage * this.props.pager.limit

        return (
            <Grid container>
                <Grid size={12}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            color: 'text.secondary',
                            mt: 2,
                        }}
                    >
                        {kedo.t('Shown items')}: &nbsp;
                        {this.props.pager.items <= currentItems
                            ? this.props.pager.items
                            : currentItems}
                        &nbsp;/&nbsp;{this.props.pager.items}
                    </Box>
                </Grid>
            </Grid>
        )
    }

    render() {
        return this.props.pager.pages && this.props.pager.pages > 0
            ? this.countItems()
            : null
    }
}

export default ItemCounter
